/* tslint:disable */

/**
 * Role of the tank security document:
 *   * SECURITY_PROTOCOL
 *   * UNLOADING_INSTRUCTIONS
 *   * PREVENTION_PLAN
 *   * STATION_MAP
 *   * OTHER
 */
type TankSecurityDocumentRole =
  'SECURITY_PROTOCOL' |
  'UNLOADING_INSTRUCTIONS' |
  'PREVENTION_PLAN' |
  'STATION_MAP' |
  'OTHER';
namespace TankSecurityDocumentRole {
  export const SECURITY_PROTOCOL: TankSecurityDocumentRole = 'SECURITY_PROTOCOL';
  export const UNLOADING_INSTRUCTIONS: TankSecurityDocumentRole = 'UNLOADING_INSTRUCTIONS';
  export const PREVENTION_PLAN: TankSecurityDocumentRole = 'PREVENTION_PLAN';
  export const STATION_MAP: TankSecurityDocumentRole = 'STATION_MAP';
  export const OTHER: TankSecurityDocumentRole = 'OTHER';
  export function values(): TankSecurityDocumentRole[] {
    return [
      SECURITY_PROTOCOL,
      UNLOADING_INSTRUCTIONS,
      PREVENTION_PLAN,
      STATION_MAP,
      OTHER
    ];
  }
}

export { TankSecurityDocumentRole }